module.exports = __webpack_public_path__ + "static/media/no-messages-icon.7adfb1d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-messages-icon.svg
// module id = 1775
// module chunks = 0